export default "__VITE_ASSET__BZ3Bzj0Q__"